<template>
  <div>
    <div style="position: relative; margin-top: -40px;" class="d-none d-md-block mb-3">
      <leaflet-map ref="fullMap" :fit-always="true" :geolocate="false" style="width: 100%; height: 500px" />
      <div id="filters-cards">
        <b-card id="shipping-filters-card">
          <b-form-group>
            <b-form-checkbox-group stacked id="checkbox-group-2" v-model="shippingsToShow" name="flavour-2">
              <b-form-checkbox value="drafts"><span class="activity-refs drafts">R</span> <translate>Received by the system</translate></b-form-checkbox>
              <b-form-checkbox value="ready"><span class="activity-refs ready">L</span> <translate>Ready to be scheduled</translate></b-form-checkbox>
              <b-form-checkbox value="ongoing"><span class="activity-refs ongoing">C</span> <translate>Ongoing Shippings</translate></b-form-checkbox>
              <b-form-checkbox value="delivered"><span class="activity-refs delivered">E</span> <translate>Shipping delivered</translate></b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-card>
      </div>
    </div>
    <b-container>
      <b-row>
        <b-col>
          <p v-translate>Note: The icons in the map shows the shipping destination of the selected statuses.</p>
          <h1><translate>Activity Dashboard for:</translate> <date-range-picker
            id="h1-date-picker"
            v-if="this.locale.daysOfWeek"
            v-model="dateRange"
            @update="dateRangeActive = true"
            :locale-data="locale"
            :opens="opens"
            class="mb-2"
            :ranges="false"
            :single-date-picker="true"
            :auto-apply="true"
          >
            <div slot="input" slot-scope="picker" style="top: 3px;position:relative">
              <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" />
              <span style="vertical-align: middle">{{moment(dateRange.startDate).format('L')}}</span>
            </div>
          </date-range-picker></h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <activity-status-card type="drafts" :start-date="moment(dateRange.startDate).format('YYYY-MM-DD')" @updated="updateShippingCollection" @completed="updatedCount++" />
        </b-col>
        <b-col sm="4">
          <activity-status-card type="ready" :start-date="moment(dateRange.startDate).format('YYYY-MM-DD')" @updated="updateShippingCollection" @completed="updatedCount++" />
        </b-col>
        <b-col sm="4">
          <activity-status-card type="ongoing" with-total :start-date="moment(dateRange.startDate).format('YYYY-MM-DD')" @updated="updateShippingCollection" @completed="updatedCount++" />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <activity-status-card type="incidences" with-total :start-date="moment(dateRange.startDate).format('YYYY-MM-DD')" cardClass="bg-warning text-dark" @updated="updateShippingCollection" @completed="updatedCount++" />
        </b-col>
        <b-col sm="4">
          <activity-status-card type="toreview" with-total :start-date="moment(dateRange.startDate).format('YYYY-MM-DD')" cardClass="bg-warning text-dark" @updated="updateShippingCollection" @completed="updatedCount++" />
        </b-col>
        <b-col sm="4">
          <activity-status-card type="delivered" :start-date="moment(dateRange.startDate).format('YYYY-MM-DD')" cardClass="bg-success text-white" @updated="updateShippingCollection" @completed="updatedCount++" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import constants from '@/common/constants'
import LeafletMap from '@/components/LeafletMap'
import ActivityStatusCard from '@/components/ActivityStatusCard.vue'
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'ActivityPage',
  title() {
    return this.$gettext('Activity')
  },
  components: {
    LeafletMap,
    ActivityStatusCard,
    DateRangePicker
  },
  data() {
    return {
      shippingCollection: {},
      shippingsToShow: ['ongoing', 'delivered'],
      currentShippings: [],
      markers: [],
      updatedCount: 0,
      dateRange: { // used for v-model prop
        startDate: this.moment(),
        endDate: this.moment()
      },
      dateRangeActive: false,
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {},
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment(), this.moment()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days'), this.moment().subtract(1, 'days')],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day'), this.moment().subtract(0, 'day').endOf('day')],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day'), this.moment().subtract(0, 'day').endOf('day')],
        [this.$gettext('This month')]: [this.moment().startOf('month'), this.moment().endOf('month')],
        [this.$gettext('This year')]: [this.moment().startOf('year'), this.moment().endOf('year')],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week'), this.moment().subtract(1, 'week').endOf('week')],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month'), this.moment().subtract(1, 'month').endOf('month')]
      },
      datepickerLocalized: false
    }
  },
  watch: {
    shippingsToShow: function (val) {
      this.updateMarkers()
    },
    markers: function (val) {
      this.$refs.fullMap.addMarkers(val)
    },
    updatedCount: function (val) {
      if (val >= 6) {
        setTimeout(function () {
          this.updateMarkers()
        }.bind(this), 2000)
      }
    }
  },
  mounted() {
    this.initDatePicker()
  },
  mixins: [constants],
  methods: {
    updateShippingCollection(obj) {
      this.shippingCollection[obj.type] = []
      this.shippingCollection[obj.type] = obj.shippings
    },
    updateMarkers() {
      if (this.updatedCount >= 6) {
        let lat
        let lng
        let icon = ''
        let shippings = []
        const markers = []
        for (let s = 0; s < this.shippingsToShow.length; s++) {
          shippings = shippings.concat(this.shippingCollection[this.shippingsToShow[s]])
        }
        for (let i = 0; i < shippings.length; i++) {
          if (shippings[i].address_to && shippings[i].address_to.lat) {
            switch (shippings[i].status) {
              case 'DRAFT':
                icon = 'https://avatars.discourse.org/v2/letter/R/444444/24.png'
                break
              case 'WAITING':
                icon = 'https://avatars.discourse.org/v2/letter/C/ff6600/24.png'
                break
              case 'READY':
                icon = 'https://avatars.discourse.org/v2/letter/L/999999/24.png'
                break
              case 'CONFIRMED':
                icon = 'https://avatars.discourse.org/v2/letter/C/ff6600/24.png'
                break
              case 'ATPICKUPPOINT':
                icon = 'https://avatars.discourse.org/v2/letter/C/ff6600/24.png'
                break
              case 'INTRANSIT':
                icon = 'https://avatars.discourse.org/v2/letter/C/ff6600/24.png'
                break
              case 'INCIDENCE':
                icon = 'https://avatars.discourse.org/v2/letter/I/FFcc00/24.png'
                break
              case 'DELIVERED':
                icon = 'https://avatars.discourse.org/v2/letter/E/28a745/24.png'
                break
              default:
                icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-van-gray.svg'
            }

            lat = shippings[i].address_to.lat
            lng = shippings[i].address_to.lng

            const statusStringsByType = shippings[i].shipping_type.name !== 'reverse' ? this.statusStrings.normal : this.statusStrings.reverse

            let infoWindowHtml = '<p>ID: <strong><a href="/shippings/' + shippings[i].id + '" target="_blank">' + this.$options.filters.uuid(shippings[i].id) + '</a></strong></p>'
            infoWindowHtml += shippings[i].status_history.length > 0 ? '<p>' + this.$gettext('Current status') + ': <strong>' + statusStringsByType[shippings[i].status_history[0].status] + '</strong></p>' : ''
            infoWindowHtml += shippings[i].status_history.length > 0 && shippings[i].status_history[0].status !== 'DELIVERED' && shippings[i].status_history[0].details ? '<p>' + this.$gettext('Status details') + ': <strong>' + this.statusReasonsStrings[shippings[i].status_history[0].details.reason] + '</strong></p>' : ''
            infoWindowHtml += '<p>' + this.$gettext('From') + ': <strong>' + shippings[i].address_from.formatted_address + '</strong></p>'
            infoWindowHtml += '<p>' + this.$gettext('To') + ': <strong>' + shippings[i].address_to.formatted_address + '</strong></p>'
            infoWindowHtml += '<p>' + this.$gettext('Last updated') + ': <strong>' + this.moment.utc(shippings[i].updated_at).local().format('YYYY-MM-DD HH:mm:ss') + '</strong></p>'
            infoWindowHtml += shippings[i].courier ? '<p>' + this.courierI18n + ': <strong>' + shippings[i].courier.name + '</strong></p>' : ''

            markers.push({
              id: 100000 + i,
              lat,
              lng,
              icon,
              x: 12,
              y: 12,
              infoText: { id: shippings[i].id, type: 'shipping', html: infoWindowHtml },
              popup: true
            })
          }
        }

        if (JSON.stringify(shippings) !== JSON.stringify(this.currentShippings)) {
          this.currentShippings = shippings
          this.markers = markers
        }
      }
    },
    initDatePicker() {
      this.locale = {
        direction: 'ltr', //  direction of text
        format: 'YYYY-MM-DD', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: this.moment().day(0) === this.moment().local().weekday(0) ? 0 : 1, //  ISO first day of week - see moment documenations for details
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.ranges = { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment(), this.moment()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days'), this.moment().subtract(1, 'days')]
      }
      this.datepickerLocalized = true
    },
    resetDateRange() {
      this.dateRange = {
        startDate: this.moment(),
        endDate: this.moment()
      }
      this.dateRangeActive = false
    },
    arrayUnique(array) {
      const a = array.concat()
      for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
          if (a[i] === a[j]) {
            a.splice(j--, 1)
          }
        }
      }
      return a
    }
  }
}
</script>
